/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';
import PopUpLink from '../../Common/GlobalPopUps/PopUpLink';

class CommentFromUserStat extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="panel-heading">
          <PopUpLink
            className="text-muted pull-right"
            hashName="fagContent"
            hashParams={{ id: 'communication_rules' }}
          >
            <i className="fa fa-exclamation-circle" /> {t('Правила общения')}
          </PopUpLink>
          <h2 className="panel-title">
            {t('Комментариев')}{' '}
            <span data-toggle="tooltip" data-placement="top" title={t('Всего')}>
              {this.props.commentsStat.total}
            </span>{' '}
            (
            <span
              className="text-success"
              data-toggle="tooltip"
              data-placement="top"
              title={t('Положительных')}
            >
              {this.props.commentsStat.likes}
            </span>{' '}
            +{' '}
            <span
              className="text-muted"
              data-toggle="tooltip"
              data-placement="top"
              title=""
              data-original-title={t('Нейтральных')}
            >
              {this.props.commentsStat.neutral}
            </span>{' '}
            +{' '}
            <span
              className="text-danger"
              data-toggle="tooltip"
              data-placement="top"
              title=""
              data-original-title={t('Отрицательных')}
            >
              {this.props.commentsStat.dislikes}
            </span>
            )
          </h2>
        </div>
      </React.Fragment>
    );
  }
}

CommentFromUserStat.propTypes = {
  commentsStat: PropTypes.shape({
    dislikes: PropTypes.number.isRequired,
    neutral: PropTypes.number.isRequired,
    likes: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired
  }).isRequired
};

export default CommentFromUserStat;



// WEBPACK FOOTER //
// ./src/components/Comment/CommentStat/CommentStat.js